<p-tag
  [value]="getStateLabel()"
  [class]="getStateClass()"
  [rounded]="true">
</p-tag>
